import gradient from "chartjs-plugin-gradient";
import moment from "moment";

const optionsOverview = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
      display: false,
    },
    title: {
      display: false,
      text: "Month Subscriber",
    },
    gradient,
  },
  scales: {
    x: {
      ticks: {
        display: false,
      },
      grid: {
        display: false,
        drawBorder: false,
      },
    },
    y: {
      ticks: {
        display: false,
      },
      grid: {
        display: false,
        drawBorder: false,
      },
    },
  },
};

const dataBarChart = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      label: "Subscribe",
      data: [6, 3, 4, 3, 6, 9, 4, 8, 9, 5, 3, 5],
      backgroundColor: "#ed2a26",
    },
  ],
};

let dayStart = moment().isoWeekday() + 1;
const weekDays = [];
for (var i = 0; i < 7; i++) {
  switch (dayStart) {
    case 1:
      weekDays.push("Mon");
      break;
    case 2:
      weekDays.push("Tue");
      break;
    case 3:
      weekDays.push("Wed");
      break;
    case 4:
      weekDays.push("Thu");
      break;
    case 5:
      weekDays.push("Fri");
      break;
    case 6:
      weekDays.push("Sat");
      break;
    case 7:
      weekDays.push("Sun");
      break;
    default:
      break;
  }

  if (dayStart < 7) {
    dayStart += 1;
  } else {
    dayStart = 1;
  }
}

const dataHorizontalDoubleLine = {
  labels: weekDays,
  datasets: [
    {
      label: "Old",
      data: [0, 4, 3, 5, 3, 7, 0],
      backgroundColor: "white",
      borderColor: "#ffc646",
    },
    {
      label: "New",
      data: [0, 2, 4.3, 8, 5, 1.8, 2.2],
      backgroundColor: "white",
      borderColor: "#ed2a26",
    },
  ],
};

const dataHorizontalLine = {
  labels: weekDays,
  datasets: [
    {
      label: "Sale",
      data: [0, 4, 3, 5, 3, 7, 0],
      backgroundColor: "white",
      borderColor: "#ffc646",
      fill: {
        target: "origin",
        below: "#ffc646", // And blue below the origin
      },
    },
  ],
};

const optionsSales = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
      display: false,
    },
    title: {
      display: false,
      text: "Month Subscriber",
    },
    gradient,
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
  },
};

const dataSales = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      //   label: "$",
      data: [
        100, 1400, 3200, 900, 4500, 5400, 1500, 7000, 3500, 2200, 3000, 1500,
      ],
      borderColor: "#ed2a26",
      backgroundColor: "white",
    },
  ],
};

const optionsUsers = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
      display: false,
    },
    title: {
      display: false,
      text: "Month Subscriber",
    },
  },
  scales: {
    x: {
      ticks: {
        display: false,
      },
      grid: {
        display: false,
      },
    },
  },
};

const dataCurrentUsers = {
  labels: [
    "1h",
    "10m",
    "50m",
    "30m",
    "40m",
    "20m",
    "30m",
    "25m",
    "20m",
    "5m",
    "10m",
  ],
  datasets: [
    {
      //   label: "$",
      data: [15, 30, 27, 43, 39, 18, 42, 25, 13, 18, 59],
      backgroundColor: "#ed2a26",
    },
  ],
};

export {
  optionsOverview,
  dataBarChart,
  dataHorizontalDoubleLine,
  dataHorizontalLine,
  optionsSales,
  dataSales,
  optionsUsers,
  dataCurrentUsers,
};
